"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _Button = _interopRequireDefault(require("../../control-components/ui-components/Button"));

var _axios = _interopRequireDefault(require("axios"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'product-updates-statistics-bar';
exports.cssAnchorName = cssAnchorName;

var GuestButton = function GuestButton() {
  var openLoginPopUp = function openLoginPopUp() {
    var event = new CustomEvent('GuestUserAction');
    window.dispatchEvent(event);
  };

  return (0, _preact.h)(_Button.default, {
    toggle: true,
    onClick: openLoginPopUp
  }, (0, _preact.h)(_phrase.default, {
    p: "events.subscribe.to.updates"
  }));
};

var SubscribeButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SubscribeButton, _Component);

  var _super = _createSuper(SubscribeButton);

  function SubscribeButton() {
    var _this;

    (0, _classCallCheck2.default)(this, SubscribeButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isSubscribed: false,
      isLoading: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleSubscription", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var isSubscribed, url;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                isLoading: true
              });

              isSubscribed = _this.state.isSubscribed;
              url = isSubscribed ? '/product-updates/unsubscribe' : '/product-updates/subscribe';
              _context.prev = 3;
              _context.next = 6;
              return _axios.default.post(url);

            case 6:
              _this.setState({
                isSubscribed: !isSubscribed
              });

            case 7:
              _context.prev = 7;

              _this.setState({
                isLoading: false
              });

              return _context.finish(7);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3,, 7, 10]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(SubscribeButton, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var result, isSubscribed;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _axios.default.get('/product-updates/subscription');

              case 2:
                result = _context2.sent;
                isSubscribed = result.data;
                this.setState({
                  isSubscribed: isSubscribed
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isSubscribed = _this$state.isSubscribed,
          isLoading = _this$state.isLoading;
      return (0, _preact.h)(_Tooltip.default, {
        customClasses: "product-updates_subscribe-btn--message",
        trigger: (0, _preact.h)(_Button.default, {
          loading: isLoading,
          toggle: true,
          toggleActive: isSubscribed,
          onClick: this.toggleSubscription
        }, isSubscribed ? (0, _preact.h)(_phrase.default, {
          p: "subscribed.to.updates"
        }) : (0, _preact.h)(_phrase.default, {
          p: "subscribe.to.updates"
        })),
        tooltipMessage: (0, _preact.h)(_phrase.default, {
          p: "product.updates.subscribe.tooltip"
        })
      });
    }
  }]);
  return SubscribeButton;
}(_preact.Component);

var StatisticsBar = function StatisticsBar(_ref2) {
  var isGuest = _ref2.isGuest,
      totalProductUpdatesCountWithoutFilters = _ref2.totalProductUpdatesCountWithoutFilters;
  return (0, _preact.h)("section", {
    className: "full-width Template-brand-stats custom-stats-bar"
  }, (0, _preact.h)("div", {
    className: "stats-bar p-v qa-stats-bar"
  }, (0, _preact.h)("div", {
    className: "sitewidth"
  }, (0, _preact.h)("div", {
    className: "col"
  }, (0, _preact.h)("ul", {
    className: "list list--stats-bar qa-stats-bar"
  }, (0, _preact.h)("li", {
    className: "list__item"
  }, (0, _preact.h)("strong", null, totalProductUpdatesCountWithoutFilters), (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
    p: "total.product.updates.counter.without.filter",
    count: {
      n: totalProductUpdatesCountWithoutFilters.toString()
    }
  })))), isGuest ? (0, _preact.h)(GuestButton, null) : (0, _preact.h)(SubscribeButton, null)))));
};

var _default = StatisticsBar;
exports.default = _default;